export function useAppLanguage() {
  // 支持的语言列表
  const supportedLanguages = [
    'zh-cn', // 简体中文
    'en-us', // 英语
    'id', // 印尼语
    'th', // 泰语
    'vi', // 越南语
    'ms', // 马来语
    'pt', // 葡萄牙语
    'es', // 西班牙语
    'ar' // 阿拉伯语
  ]

  /**
   * 获取有效的语言代码
   * 规则：
   * 1. 如果 lang 没有传，默认 zh-cn
   * 2. 如果 lang 传了但不在支持列表中，默认 en-us
   * 3. 如果 lang 传了且在支持列表中，使用该语言
   * @param lang 语言代码
   * @returns 有效的语言代码
   */
  const getValidLanguage = (lang?: string): string => {
    if (!lang) {
      return 'zh-cn'
    }

    const lowerLang = lang.toLowerCase()
    if (supportedLanguages.includes(lowerLang)) {
      return lowerLang
    }

    return 'en-us'
  }

  return {
    getValidLanguage,
    supportedLanguages
  }
}
